// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box-card[data-v-026a348b] .el-form-item {\n  margin-bottom: 0;\n}\n.box-card[data-v-026a348b] .el-form-item__error {\n  position: static;\n}\n.addStyle[data-v-026a348b], .deleteStyle[data-v-026a348b] {\n  cursor: pointer;\n}\n.addStyle[data-v-026a348b] {\n  color: #409eff;\n}\n.deleteStyle[data-v-026a348b] {\n  color: #f56c6c;\n}\n", ""]);
// Exports
module.exports = exports;
